import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import de from '../public/locales/de/translation.json'
import en from '../public/locales/en/translation.json'
import { DEFAULT_LANGUAGE, getInitialLanguage } from './utils/language'

const resources = {
  de: { translation: de },
  en: { translation: en },
}

const initialLanguage = getInitialLanguage()
// CookieFirst runs with forcedLang "inherit" and reads <html lang> when it initializes
document.documentElement.lang = initialLanguage

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: true,
    },
  })

export default i18n
